<template>
  <div>
    <ModuleHeader>Editor de ventas</ModuleHeader>
    <v-overlay :value="loadingData">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col md="12" cols="12">
        <v-card>
          <v-card-text>
            <p class="text-subtitle-1">Filtros</p>
            <v-row>
              <v-col md="10" cols="12">
                <v-text-field v-model="input_folio" label="Folio de Venta" hide-details></v-text-field>
              </v-col>
              <v-col md="1" class="d-flex align-end">
                <v-btn depressed @click="getVentas()" color="success">
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-card v-if="dataVenta" class="mt-4 px-1 pb-1">
      <!-- DATOS DE VENTA -->
      <v-row class="ma-1">
        <v-col md="6" cols="12">
          <v-text-field type="text" label="Cliente" :value="dataVenta.Cliente ? dataVenta.Cliente.Nombre : ''"
            placeholder="First Name" readonly hide-details />
        </v-col>
        <v-col md="3" cols="12">
          <v-text-field type="text" label="Folio" :value="dataVenta.Folio ? dataVenta.Folio : ''" placeholder="Folio"
            readonly hide-details />
        </v-col>
        <v-col md="3" cols="12">
          <v-text-field type="text" label="Departamento" :value="dataVenta.depto ? dataVenta.depto.Nombre : ''"
            placeholder="Departamento" readonly hide-details />
        </v-col>
        <v-col md="3" cols="12">
          <v-text-field type="text" :value="dataVenta.FechaVenta ? dataVenta.FechaVenta : ''" label="Fecha"
            placeholder="fecha" readonly hide-details />
        </v-col>
        <v-col md="3" cols="12">
          <v-text-field type="text" :value="dataVenta.fechaHora ? dataVenta.fechaHora : ''" label="Hora de venta"
            placeholder="hora de venta" readonly hide-details />
        </v-col>
        <v-col md="3" cols="12">
          <v-text-field type="text" label="ID de Turno" :value="dataVenta.Turno ? dataVenta.Turno : ''"
            placeholder="Turno" readonly hide-details />
        </v-col>
        <v-col md="3" cols="12">
          <v-text-field type="text" label="Apertura de turno" :value="dataVenta.apertura ? dataVenta.apertura : ''"
            placeholder="Apertura de turno" readonly hide-details />
        </v-col>
        <v-col md="2" cols="12">
          <v-text-field type="text" label="Total pagado" :value="dataVenta.objectCambio
              ? $pgsHelper.formatNumber(dataVenta.totalMXN) +
              ' ' +
              $Currencies.getCurrencyDefault()
              : 0
            " placeholder="Cambio" readonly hide-details />
        </v-col>
        <v-col md="2" cols="12">
          <v-text-field type="text" label="Cambio" :value="dataVenta.objectCambio
              ? $pgsHelper.formatNumber(dataVenta.objectCambio.cantidad) +
              ' ' +
              $Currencies.getCurrencyDefault()
              : 0
            " placeholder="Cambio" readonly hide-details />
        </v-col>
        <v-col md="2" cols="12">
          <v-text-field type="text" label="Total" :value="dataVenta.Total
              ? $pgsHelper.formatNumber(dataVenta.Total) +
              ' ' +
              $Currencies.getCurrencyDefault()
              : 0
            " placeholder="Total" readonly hide-details />
        </v-col>
        <v-col md="3" cols="12">
          <v-text-field type="text" :value="dataVenta.Caja
              ? $pgsHelper.getById(data_cajas, 'id', dataVenta.Caja).Nomb
              : ''
            " label="Caja" placeholder="caja" readonly hide-details />
        </v-col>
        <v-col md="3" cols="12">
          <v-text-field type="text" :value="dataVenta.Cajero
              ? $pgsHelper.getById(cashiers, 'Id', dataVenta.Cajero).Nomb
              : ''
            " label="Cajero" placeholder="cajero" readonly hide-details />
        </v-col>

        <v-divider class="my-5"></v-divider>
        <!-- DIVISOR -->
        <v-container>
          <v-divider class="my-5"></v-divider>
        </v-container>

        <!-- PRODUCTOS -->
        <v-col md="12">
          <p class="text-h6">Productos</p>
          <v-simple-table class="elevation-1">
            <thead>
              <tr>
                <th>Productos</th>
                <th>Cantidad</th>
                <th>Precio U.</th>
                <th>Precio Total</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(producto, index) in dataVenta.Catalogo
                ? dataVenta.Catalogo
                : []">
                <tr :key="index">
                  <td data-label="producto">
                    {{ producto.Nombre }}
                    <li style="font-weight: 300" v-if="
                      producto.ExtraParams &&
                      producto.ExtraParams.AYB &&
                      producto.ExtraParams.AYB.Mesero
                    ">
                      Agregado por:
                      {{
                        $pgsHelper.getById(
                          meseros,
                          "id",
                          producto.ExtraParams.AYB.Mesero
                        ).Nombre
                      }}
                    </li>
                    <template v-for="(modi, idx) in producto.ModificadoresList">
                      <li :key="idx">
                        {{ modi.Cnt }} - {{ modi.nam }} {{ modi.pco.C }}
                        {{ modi.pco.M }}
                      </li>
                    </template>
                    <template v-for="(Desc, idx) in producto.Descuentos">
                      <li :key="idx + 1000">
                        {{ Desc.Cnt }} - {{ Desc.Dsc }} {{ Desc.Ttl.C }}
                        {{ Desc.Ttl.M }}
                      </li>
                    </template>
                    <template v-for="(modi, idx) in producto.Catalogo">
                      <li v-if="
                        modi.Tipo !== 'AYB-Insumo' &&
                        modi.Tipo !== 'AYB-ICompuesto'
                      " :key="idx + 'cuentaCobrar'">
                        {{ modi.Cnt }} - {{ modi.Nombre }}
                        {{ modi.Pco ? modi.Pco.C : 0 }}
                        {{ modi.Pco ? modi.Pco.M : "" }}
                      </li>
                    </template>
                  </td>
                  <td data-label="Cantidad">{{ producto.Cnt }}</td>
                  <td data-label="Precio">
                    {{ producto.Pco.C }} {{ producto.Pco.M }}
                  </td>
                  <td data-label="Precio">
                    {{ $pgsHelper.formatNumber(producto.TotalReal) }}
                    {{ producto.Pco.M }}
                  </td>
                </tr>
              </template>
              <tr>
                <td>Totales</td>
                <td></td>
                <td></td>
                <td>
                  {{ $pgsHelper.formatNumber(dataVenta.sumatoriaTotal) }}
                  {{ $Currencies.getCurrencyDefault() }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>

        <!-- ALERTA -->
        <v-col md="12" v-if="dataVenta.isDevo">
          <v-alert color="red" type="warning">
            Esta venta está devuelta, no es posible hacer cambios.
          </v-alert>
        </v-col>

        <v-row align="stretch">
          <!-- VENTA ORIGINAL -->
          <v-col md="6">
            <v-card style="min-height: 100%; display: flex; flex-wrap: wrap">
              <v-card-title>Venta Original</v-card-title>

              <!-- TABS -->
              <v-tabs grow>
                <v-tab> Pagos </v-tab>
                <v-tab> Propinas </v-tab>

                <!-- PAGOS -->
                <v-tab-item>
                  <p class="text-h6">Pagos</p>
                  <v-simple-table class="elevation-1">
                    <thead>
                      <tr>
                        <th>Pago</th>
                        <th>Monto</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(pago, index) in dataVenta.Pagos
                        ? dataVenta.Pagos
                        : []">
                        <tr :key="index">
                          <td data-label="Pago">
                            <v-row>
                              <v-col md="12" style="align-self: center">
                                <span> {{ pago.TipoPago }} </span>
                              </v-col>
                            </v-row>
                          </td>

                          <td data-label="Precio">
                            <span>
                              {{ $pgsHelper.formatNumber(pago.Cantidad) }}
                              {{ pago.Moneda }}
                            </span>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </v-simple-table>
                </v-tab-item>

                <!-- PROPINAS -->
                <v-tab-item>
                  <p class="text-h6">Propinas</p>
                  <div v-if="dataVenta.Props && Object.keys(dataVenta.Props).length > 0">
                    <v-simple-table class="elevation-1">
                      <thead>
                        <tr>
                          <th>Propina</th>
                          <th>Monto</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="(prop, key) in dataVenta.Props
                          ? dataVenta.Props
                          : []">
                          <tr :key="key + 2000">
                            <!------------------------------------------------->

                            <td data-label="Propina">
                              <v-row>
                                <v-col md="10" style="align-self: center">
                                  <span>
                                    {{
                                      getPayMethods[key].Nombre
                                        ? getPayMethods[key].Nombre
                                        : key
                                    }}
                                  </span>
                                </v-col>
                              </v-row>
                            </td>

                            <td data-label="Precio">
                              <span>{{
                                $pgsHelper.formatNumber(prop.Cantidad)
                                }}</span>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </v-simple-table>
                  </div>
                  <div v-else>
                    <h5>Esta venta no cuenta con propinas</h5>
                  </div>
                </v-tab-item>
              </v-tabs>

              <!-- TOTALES ORIGINALES -->
              <v-col md="12" style="
                  justify-items: center;
                  align-self: end;
                  padding-bottom: 136px;
                ">
                <v-simple-table class="elevation-1" style="max-width: 50%">
                  <thead>
                    <tr>
                      <th>Totales</th>
                      <th>Cantidad</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Total pagado</td>
                      <td>
                        {{ $pgsHelper.formatNumber(dataVenta.totalMXN) }} {{ $Currencies.getCurrencyDefault() }}
                      </td>
                    </tr>
                    <tr style="background-color: lightblue">
                      <td>Cambio</td>
                      <td>
                        {{
                          dataVenta.objectCambio
                            ? $pgsHelper.formatNumber(
                              dataVenta.objectCambio.cantidad
                            ) +
                            " " +
                            $Currencies.getCurrencyDefault()
                            : 0
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>Total Venta</td>
                      <td>
                        {{ $pgsHelper.formatNumber(dataVenta.sumatoriaTotal) }}
                        {{ $Currencies.getCurrencyDefault() }}
                      </td>
                    </tr>
                    <tr>
                      <td>Total Propinas</td>
                      <td>{{ $pgsHelper.formatNumber(totPropsOrig) }} {{ $Currencies.getCurrencyDefault() }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-card>
          </v-col>

          <!-- VENTA MODIFICADA -->
          <v-col md="6">
            <v-card>
              <v-card-title> Venta Modificada </v-card-title>
              <v-card-text>
                <v-tabs v-model="tabModificada" grow>
                  <v-tab> Pagos </v-tab>
                  <v-tab> Propinas </v-tab>
                  <v-tab @click="showTicket()"> Ticket </v-tab>

                  <!-- PAGOS -->
                  <v-tab-item>
                    <p class="text-h6">Pagos</p>
                    <v-simple-table class="elevation-1">
                      <thead>
                        <tr>
                          <th>Pago</th>
                          <th>Monto</th>
                          <th class="editsButtons" v-if="!dataVenta.isDevo">
                            Editar
                          </th>
                          <th class="editsButtons" v-if="!dataVenta.isDevo">
                            Eliminar
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="(pago, index) in dataVenta.arrayPagos
                          ? dataVenta.arrayPagos
                          : []">
                          <tr :key="index">
                            <td data-label="Pago">
                              <v-row>
                                <v-col md="12" style="align-self: center">
                                  <v-autocomplete :items="$pgsHelper.ArrayObjectToArray(
                                    getPayMethods
                                  )
                                    " item-value="id" item-text="Nombre" v-if="pago.locked" v-model="pago.tipo"
                                    @input="refreshName(index, pago.tipo, 0)" dense></v-autocomplete>
                                  <span v-else> {{ pago.TipoPago }} </span>
                                </v-col>
                              </v-row>
                            </td>

                            <td data-label="Precio">
                              <v-text-field type="number" v-if="pago.locked" v-model="pago.Cantidad" dense>
                              </v-text-field>
                              <span v-else>
                                {{ $pgsHelper.formatNumber(pago.Cantidad) }}
                                {{ pago.Moneda }}
                              </span>
                            </td>

                            <td class="editsButtons" v-if="!dataVenta.isDevo">
                              <v-btn @click="unlockDataEdit(index, 0)" text small
                                :class="!pago.locked ? 'ma-1' : 'mt-3'">
                                <v-icon small>{{
                                  !pago.locked ? "mdi-lock" : "mdi-lock-open"
                                  }}</v-icon></v-btn>
                            </td>

                            <td class="editsButtons" v-if="!dataVenta.isDevo">
                              <v-btn text small style icon
                                @click="spliceRow(0, index)"><v-icon>mdi-delete</v-icon></v-btn>
                            </td>
                          </tr>
                        </template>

                        <template v-if="!dataVenta.isDevo">
                          <tr>
                            <td colspan="4" class="text-center">
                              <v-btn plain block small @click="addRow(0)">Añadir pago
                                <v-icon>mdi-plus-box</v-icon></v-btn>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </v-simple-table>
                  </v-tab-item>

                  <!-- PROPINAS -->
                  <v-tab-item>
                    <p class="text-h6">Propinas</p>
                    <v-simple-table class="elevation-1">
                      <thead>
                        <tr>
                          <th>Propina</th>
                          <th>Monto</th>
                          <th class="editsButtons" v-if="!dataVenta.isDevo">
                            Editar
                          </th>
                          <th class="editsButtons" v-if="!dataVenta.isDevo">
                            Eliminar
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="(prop, key) in dataVenta.arrayProps
                          ? dataVenta.arrayProps
                          : []">
                          <tr :key="key + 2000">
                            <!------------------------------------------------->

                            <td data-label="Propina">
                              <v-row>
                                <v-col md="10" style="align-self: center">
                                  <v-autocomplete :items="$pgsHelper.ArrayObjectToArray(
                                    getPayMethods
                                  )
                                    " item-value="id" item-text="Nombre" v-if="prop.locked" v-model="prop.tipo"
                                    @input="refreshName(key, prop.tipo, 1)" dense></v-autocomplete>
                                  <span v-else> {{ prop.Nombre }} </span>
                                </v-col>

                                <!-- <v-col md="2">
                                <v-btn
                                  @click="unlockDataEdit(key, 1)"
                                  text
                                  small
                                  style="float: inline-end"
                                  :class="!prop.locked ? 'ma-1' : 'mt-3'"
                                >
                                  <v-icon small>{{
                                    !prop.locked ? "mdi-lock" : "mdi-lock-open"
                                  }}</v-icon></v-btn
                                >
                              </v-col> -->
                              </v-row>
                            </td>

                            <td data-label="Precio">
                              <v-text-field type="number" v-if="prop.locked" v-model="prop.Cantidad"
                                dense></v-text-field>
                              <span v-else>{{
                                $pgsHelper.formatNumber(prop.Cantidad)
                                }}</span>
                            </td>

                            <td class="editsButtons" v-if="!dataVenta.isDevo">
                              <v-btn @click="unlockDataEdit(key, 1)" text small style="float: inline-end"
                                :class="!prop.locked ? 'ma-1' : 'mt-3'">
                                <v-icon small>{{
                                  !prop.locked ? "mdi-lock" : "mdi-lock-open"
                                  }}</v-icon></v-btn>
                            </td>

                            <td class="editsButtons" v-if="!dataVenta.isDevo">
                              <v-btn text small style icon
                                @click="spliceRow(1, index)"><v-icon>mdi-delete</v-icon></v-btn>
                            </td>
                          </tr>
                        </template>
                        <template v-if="!dataVenta.isDevo">
                          <tr>
                            <td colspan="4" class="text-center">
                              <v-btn plain block @click="addRow(1)">Añadir propina
                                <v-icon>mdi-plus-box</v-icon></v-btn>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </v-simple-table>
                    <!-- <v-row>
                    <v-col md="12">
                      <v-btn class="ma-1" color="green" dark block @click="saveData()"
                        >Guardar</v-btn
                      >
                    </v-col>
                  </v-row> -->
                  </v-tab-item>

                  <v-tab-item>
                    <v-overlay :value="loadingTicket" v-if="loadingTicket">
                      <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                    <IframeTicket style="width: 22rem; justify-self: center" v-else-if="tabModificada === 2"
                      :lmth="lmth" :faltaDinero="faltaDinero"></IframeTicket>
                  </v-tab-item>
                </v-tabs>

                <!-- TOTALES MODIFICADOS -->
                <v-col md="12" style="justify-items: center">
                  <v-simple-table class="elevation-1" style="max-width: 50%">
                    <thead>
                      <tr>
                        <th>Totales</th>
                        <th>Cantidad</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Total Pagado</td>
                        <td>
                          {{ $pgsHelper.formatNumber(totalesPagos.totalMXN) }}
                          {{ $Currencies.getCurrencyDefault() }}
                        </td>
                      </tr>
                      <tr v-if="!faltaDinero" style="background-color: lightblue">
                        <td>Cambio</td>
                        <td>
                          {{ $pgsHelper.formatNumber(totalesPagos.cambio) }} {{ $Currencies.getCurrencyDefault() }}
                        </td>
                      </tr>

                      <tr v-if="noCuadra || faltaDinero" :style="faltaDinero
                          ? 'background-color: rgba(255, 0, 0, 0.533);'
                          : 'background-color: rgb(255 86 0 / 53%)'
                        ">
                        <td colspan="2" v-if="faltaDinero">
                          Hace falta dinero para completar la venta.
                        </td>
                        <td colspan="2" v-else>
                          Está modificando el cambio de la venta.
                        </td>
                      </tr>
                      <tr>
                        <td>Total Venta</td>
                        <td>
                          {{
                            $pgsHelper.formatNumber(
                              this.dataVenta.sumatoriaTotal
                            )
                          }}
                          {{ $Currencies.getCurrencyDefault() }}
                        </td>
                      </tr>
                      <tr>
                        <td>Total Propinas</td>
                        <td>{{ $pgsHelper.formatNumber(totalesProps) }} {{ $Currencies.getCurrencyDefault() }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>

                <v-col md="12">
                  <v-btn class="ma-1" color="error" dark block @click="getVentas()" v-if="!dataVenta.isDevo">Descartar
                    cambios</v-btn>
                  <v-btn class="ma-1" color="green" dark block @click="saveData()"
                    :disabled="faltaDinero || dataVenta.isDevo">Guardar</v-btn>
                </v-col>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-row>
    </v-card>
    <v-card v-else class="mt-2">
      <h5 class="ma-1">{{ placeholder }}</h5>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import Modificadores from "../../../clases/Modificadores.js";
// import PGSHelper from "../../helpers/PGSHelper.js";
import TicketVenta from "../../../clases/TicketVenta.js";
import ticketDevolucion from "../../../tickets/ticketDevolucion.vue";
import ticket from "../../../tickets/ticketReprint.vue";
import Currencies from "../../../clases/Currencies";
import IframeTicket from "./IframeTicket.vue";

export default {
  name: "EditorVentas",
  components: {
    IframeTicket,
  },
  data() {
    return {
      tabModificada: 0,
      loadingData: false,
      input_folio: "",
      dataVenta: null,
      keyResume: 0,
      data_cajas: [],
      meseros: [],
      cashiers: [],
      placeholder: "Pulse el botón de buscar",
      loadingTicket: false,
      lmth: null,
    };
  },
  methods: {
    async showTicket(sinPrecio = false) {
      this.loadingTicket = true;
      const res = this.venta;
      // console.log("resventa", res);
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/CONF/" + res.Departamento
        );
      let resultConf = data.val();
      let cssTicket = await this.$pgsHelper.getTicketCss();
      let tipoCambio = await this.getTipoCambio(res.TipoCambio);
      res.TC = tipoCambio.TC;

      let dataToTicket = res;

      const pago = {};
      Object.keys(res.arrayPagos).map((key) => {
        const obj = res.arrayPagos[key];
        const tipo = obj.tipo;
        pago[tipo] = {
          Cantidad: obj.Cantidad,
          IdTran: obj.IdTran,
          Moneda: obj.Moneda,
          TipoPago: obj.TipoPago,
        };
      });

      dataToTicket.Pagos = pago;

      const prop = {};

      Object.keys(res.arrayProps).map((key) => {
        const obj = res.arrayProps[key];
        const tipo = obj.tipo;
        prop[tipo] = {
          Cantidad: Number(obj.Cantidad),
          IdTran: obj.IdTran,
        };
      });

      dataToTicket.Props = prop;

      let Cajero = this.$pgsHelper.getById(this.cashiers, "Id", res.Cajero);
      dataToTicket.cajero = { NombreCajero: Cajero.Nomb || "Sin Cajero" };
      dataToTicket.sinPrecio = sinPrecio;
      dataToTicket.Depto = resultConf;
      let TVenta = new TicketVenta(dataToTicket);
      TVenta.dataToTicketReprint();
      let ticketHtml = this.$pgsHelper.getHtmlFromComponent(
        this,
        res.isDevo ? ticketDevolucion : ticket,
        {
          dataToTicket: TVenta,
          currenciDefault: Currencies.getCurrencyDefault()
        }
      );
      let html = "";
      html += "<html><head><title>" + document.title + "</title>";
      html += "<style>" + cssTicket + "</style>";
      html += "</head><body >";

      html += ticketHtml;
      html += "</body></html>";
      this.lmth = html;
      this.loadingTicket = false;
    },
    async getApertura(venta) {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("Turno", "==", venta.Turno),
        firestore.where("Tipo", "==", "Apertura"),
      ];
      const data = await firestore.queryBuilder("PDV_CierreApertura", filter);
      const momento = data.docs[0].data();
      this.dataVenta.apertura = new moment(momento.FechaCreacion).format(
        "YYYY-MM-DD hh:mm"
      );
    },
    async getTipoCambio(id) {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const doc = firestore.doc("PDV_TipoCambio", id);

      const tc = await firestore.getDoc(doc);
      let tcdoc = { Id: tc.ref.id, ...tc.data() };
      return tcdoc;
    },

    spliceRow(tipo, index) {
      const type = tipo == 0 ? "Pago" : "Propina";
      this.$swal({
        title: `Eliminar ${type}`,
        text: `¿Desea eliminarle definitivamente?`,
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
      }).then(async (result) => {
        if (result.value) {
          // tipo 0 es para pagos, tipo 1 es para propinas
          if (tipo === 0) {
            this.dataVenta.arrayPagos.splice(index, 1);
          }
          if (tipo === 1) {
            this.dataVenta.arrayProps.splice(index, 1);
          }
        }
      });
    },
    addRow(tipo) {
      // tipo 0 es para pagos, tipo 1 es para propinas
      if (tipo === 0) {
        this.dataVenta.arrayPagos.push({
          Cantidad: 0,
          IdTran: "",
          Moneda: "",
          TipoPago: "",
          locked: true,
          tipo: "",
        });
      }
      if (tipo === 1) {
        this.dataVenta.arrayProps.push({
          Cantidad: 0,
          IdTran: "",
          Nombre: "",
          locked: true,
          tipo: "",
        });
      }
    },
    saveData() {
      let successData = {};
      const res = this.venta;

      const pago = {};
      Object.keys(res.arrayPagos).map((key) => {
        const obj = res.arrayPagos[key];
        const tipo = obj.tipo;
        pago[tipo] = {
          Cantidad: Number(obj.Cantidad),
          CantidadMXN: this.$Currencies.getExchangeRateByCurrency(
            Number(obj.Cantidad),
            obj.Moneda,
            Currencies.getCurrencyDefault()
          ),
          IdTran: obj.IdTran,
          Moneda: obj.Moneda,
          TipoPago: obj.TipoPago,
        };
      });

      successData.Pagos = pago;

      const props = {};

      Object.keys(res.arrayProps).map((key) => {
        const obj = res.arrayProps[key];
        const tipo = obj.tipo;
        const moneda = obj.tipo.split("_")[1] ? obj.tipo.split("_")[1] : "";
        // console.log(obj, "0obj");
        props[tipo] = {
          Cantidad: Number(obj.Cantidad),
          CantidadMXN: this.$Currencies.getExchangeRateByCurrency(
            Number(obj.Cantidad),
            obj.Moneda,
            Currencies.getCurrencyDefault()
          ),
          IdTran: obj.IdTran,
        };
      });

      successData.Props = props;
      successData.Id = this.dataVenta.id;
      successData.Total = this.dataVenta.Total;
      successData.Cambio = { MXN: this.totalesPagos.cambio };
      successData.Upat = this.dataVenta.Upat
        ? this.dataVenta.Upat
        : this.dataVenta.FechaCreacion;

      // console.log("successdata", successData);

      this.$swal({
        title: "Deseas guardar los cambios?",
        text: "Los pagos editados serán modificados",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Ventas-updatePagosVenta", successData)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Datos guardados",
              "Los datos fueron guardados exitosamente",
              "success"
            );

            this.showModal = false;
            this.getVentas();
          } else {
            this.$swal(
              "Error al guardar los datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    unlockDataEdit(index, tipo) {
      if (tipo == 0) {
        this.dataVenta.arrayPagos[index].locked =
          !this.dataVenta.arrayPagos[index].locked;
      } else {
        this.dataVenta.arrayProps[index].locked =
          !this.dataVenta.arrayProps[index].locked;
      }
    },
    refreshName(index, pago, tipo) {
      // console.log(pago);
      // tipo == 0 es pago
      if (tipo == 0) {
        const moneda = pago.split("_")[1] ? pago.split("_")[1] : "";
        const monedaCambio = moneda == "USD" ? "MXN" : "USD";
        const Nombre = this.getPayMethods[pago].Nombre;
        if (this.dataVenta.arrayPagos[index].Moneda !== moneda) {
          this.dataVenta.arrayPagos[index].Cantidad =
            this.$Currencies.getExchangeRateByCurrency(
              this.dataVenta.arrayPagos[index].Cantidad,
              monedaCambio,
              moneda
            );
          this.dataVenta.arrayPagos[index].Moneda = moneda;
        }

        this.dataVenta.arrayPagos[index].TipoPago = Nombre;

        // tipo == 1 es propina
      } else if (tipo == 1) {
        const moneda = pago.split("_")[1] ? pago.split("_")[1] : "";
        const monedaCambio = moneda == "USD" ? "MXN" : "USD";
        const Nombre = this.getPayMethods[pago].Nombre;

        if (this.dataVenta.arrayProps[index].Moneda !== moneda) {
          this.dataVenta.arrayProps[index].Cantidad =
            this.$Currencies.getExchangeRateByCurrency(
              this.dataVenta.arrayProps[index].Cantidad,
              moneda,
              Currencies.getCurrencyDefault()
            );
          this.dataVenta.arrayProps[index].Moneda = moneda;
        }
        this.dataVenta.arrayProps[index].Nombre = Nombre;
      }
    },
    /* refreshMonto(index, pago, tipo) {
      if (tipo == 0) {
        const Nombre = this.getPayMethods[pago].Nombre;

        this.dataVenta.arrayPagos[index].TipoPago = Nombre;
      } else if (tipo == 1) {
        const Nombre = this.getPayMethods[pago].Nombre;
        this.dataVenta.arrayProps[index].Nombre = Nombre;
      }
    }, */
    async getVentas() {
      this.loadingData = true;
      let data_ventas = [];
      if (this.input_folio != "") {
        const firestore = this.$store.getters.getFirebaseApp.firestore;

        let filter = [
          firestore.where("Folio", "==", this.input_folio),
          firestore.where(
            "Tenant",
            "==",
            this.$store.getters.getFirebaseApp.tenant
          ),
        ];
        const data = await firestore.queryBuilder("PDV_Ventas", filter);
        let preData = [];
        preData = data.docs.map((doc) => {
          return { id: doc.ref.id, ...doc.data() };
        });
        // console.log("predata", preData);
        data_ventas = preData;
      } else {
        this.placeholder = "Favor de introducir un folio";
      }

      if (data_ventas[0]) {
        data_ventas[0].fecha = new moment(data_ventas[0].FechaCreacion).format(
          "YYYY-MM-DD"
        );
        data_ventas[0].fechaHora = new moment(
          data_ventas[0].FechaCreacion
        ).format("HH:mm");
        data_ventas[0].NombreCliente = data_ventas[0].Cliente.Nombre;
        data_ventas[0].AliasVenta = data_ventas[0].Cliente.Apodo;
        data_ventas[0].CajaName = this.$pgsHelper.getById(
          this.data_cajas,
          "id",
          data_ventas[0].Caja
        ).Nomb;
        data_ventas[0].CajeroName = this.$pgsHelper.getById(
          this.cashiers,
          "Id",
          data_ventas[0].Cajero
        ).Nomb;

        data_ventas[0].Catalogo.forEach((prod) => {
          prod.ivaPercent = this.$pgsHelper.getIvaByFamilia(
            this.familias,
            prod.Familia.I
          );
        });
      }

      if (data_ventas[0]) {
        let venta = this.$pgsHelper.cloneObj(data_ventas[0]);
        let totales = 0;
        venta.totalMXN = 0;
        venta.arrayPagos = [];
        venta.arrayProps = [];
        venta.objectCambio = {};

        for (const property in venta.Catalogo) {
          let totalProd = 0;
          if (venta.Catalogo[property].Modificadores) {
            venta.Catalogo[property].ModificadoresList =
              Modificadores.parseToListOption(
                venta.Catalogo[property].Modificadores
              );
            let totalModi = 0;
            venta.Catalogo[property].ModificadoresList.forEach((modi) => {
              totalModi += modi.pco.C;
            });
            venta.Catalogo[property].totalModi = totalModi;
          }
          if (venta.Catalogo[property].Pagos) {
            Object.entries(venta.Catalogo[property].Pagos).forEach((pago) => {
              totales += pago[1].def.C;
              totalProd += pago[1].def.C;
            });
          }
          venta.Catalogo[property].TotalReal = Number(totalProd);
        }

        for (const pago in venta.Pagos) {
          venta.arrayPagos.push({
            locked: false,
            tipo: pago,
            ...venta.Pagos[pago],
          });
        }

        if (venta.arrayPagos) {
          venta.arrayPagos.forEach((pago) => {
            const moneda = pago.tipo.split("_")[1]
              ? pago.tipo.split("_")[1]
              : "";
            if (pago.Moneda !==  Currencies.getCurrencyDefault()) {
              const cambio = this.$Currencies.getExchangeRateByCurrency(
                pago.Cantidad,
                moneda,
                Currencies.getCurrencyDefault()
              );
              venta.totalMXN += cambio;
            } else {
              venta.totalMXN += Number(pago.Cantidad);
            }
          });
        }

        if (venta.Props) {
          for (const propina in venta.Props) {
            const moneda = propina.split("_")[1] ? propina.split("_")[1] : "";
            venta.arrayProps.push({
              Nombre: this.getPayMethods[propina].Nombre,
              locked: false,
              Moneda: moneda,
              tipo: propina,
              ...venta.Props[propina],
            });
          }
        }

        if (venta.Cambio) {
          const entries = Object.entries(venta.Cambio);
          venta.objectCambio = {
            currency: entries[0][0],
            cantidad: entries[0][1],
          };
        }
        const departamentos = this.$store.getters.getPDVDepartamentos;
        venta.depto = this.$pgsHelper.getById(
          departamentos,
          "id",
          venta.Departamento
        );

        venta.isVenta = true;
        venta.isDevo = !!venta.Devos;

        venta.sumatoriaTotal = totales;

        this.dataVenta = venta;

        // console.log("dataventa", this.dataVenta);

        await this.getApertura(venta);
        this.keyResume++;

        if (this.tabModificada == 2) {
          this.showTicket();
        }
      }
      this.loadingData = false;
    },
    async getCajas() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajas"
        );
      this.data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getCashiers() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajeros"
        );

      if (snapshot.exists()) {
        this.cashiers = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            // ajustar usuarios antiguos
            this.cashiers.push(toAdd);
          }
        });
      }
    },
    async getMeserosAB() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Meseros"
        );
      if (snapshot.exists()) {
        this.meseros = [];
        this.meseros = this.$pgsHelper.ArrayObjectToArray(snapshot.val());
        this.meseros.forEach((mesero) => {
          let deptos = Object.entries(mesero.Deptos);
          let textDepto = "";
          deptos.forEach((depto) => {
            let testDepto = this.$pgsHelper.getById(
              this.departamentos,
              "Id",
              depto[0]
            );
            if (testDepto) {
              textDepto = textDepto + testDepto.Nombre + " ";
            }
          });
          mesero.DepartamentoText = textDepto;
        });
      }
    },
  },

  computed: {
    noCuadra() {
      return (
        (this.dataVenta.objectCambio
          ? this.dataVenta.objectCambio.cantidad
          : 0) !== this.totalesPagos.cambio
      );
    },
    faltaDinero() {
      return this.totalesPagos.totalMXN < this.dataVenta.sumatoriaTotal;
    },

    totalesPagos() {
      let totalMXN = 0;
      this.dataVenta.arrayPagos.forEach((pago) => {
        const moneda = pago.tipo.split("_")[1] ? pago.tipo.split("_")[1] : "";
        if (pago.Moneda !==  Currencies.getCurrencyDefault()) {
          const cambio = this.$Currencies.getExchangeRateByCurrency(
            pago.Cantidad,
            moneda,
            Currencies.getCurrencyDefault()
          );
          totalMXN += cambio;
        } else {
          totalMXN += Number(pago.Cantidad);
        }
      });
      const totalesPagos = {
        totalMXN: totalMXN,
        cambio: totalMXN - this.dataVenta.sumatoriaTotal,
      };
      return totalesPagos;
    },
    totPropsOrig() {
      let totalPropMXN = 0;
      const res = this.$pgsHelper.cloneObj(this.dataVenta);
      if (res.Props) {
        Object.keys(res.Props).map((key) => {
          // console.log(key);
          const moneda = key.split("_")[1] ? key.split("_")[1] : "";
          const obj = res.Props[key];
          if (obj.moneda !==  Currencies.getCurrencyDefault()) {
            const cambio = this.$Currencies.getExchangeRateByCurrency(
              obj.Cantidad,
              moneda,
              Currencies.getCurrencyDefault()
            );
            totalPropMXN += cambio;
          } else {
            totalPropMXN += Number(obj.Cantidad);
          }
        });
      }
      return totalPropMXN;
    },
    totalesProps() {
      let totalPropMXN = 0;
      if (this.dataVenta.arrayProps) {
        this.dataVenta.arrayProps.forEach((prop) => {
          const moneda = prop.tipo.split("_")[1] ? prop.tipo.split("_")[1] : "";
          if (prop.moneda !==  Currencies.getCurrencyDefault()) {
            const cambio = this.$Currencies.getExchangeRateByCurrency(
              prop.Cantidad,
              moneda,
              Currencies.getCurrencyDefault()
            );
            totalPropMXN += cambio;
          } else {
            totalPropMXN += Number(prop.Cantidad);
          }
        });
      }
      return totalPropMXN;
    },
    getPayMethods() {
      const pagos = {};

      this.$store.getters.getPDVPagosTipos.forEach((pago) => {
        if (pago.Moneda == "All") {
          this.$store.getters.getPDVMonedasLista.forEach((tipo) => {
            if (tipo.id !== "BTC" && tipo.id !== "XXX") {
              pagos[pago.id + "_" + tipo.id] = {
                id: pago.id + "_" + tipo.id,
                Nombre: pago.Nombre + " " + tipo.Nombre,
              };
            }
          });
        } else if (pago.Moneda == "None") {
          // pagos[pago.id] = { id: pago.id, Nombre: pago.Nombre };
        } else {
          this.$store.getters.getPDVMonedasLista.forEach((tipo) => {
            if (tipo.id == pago.Moneda) {
              pagos[pago.id + "_" + tipo.id] = {
                id: pago.id + "_" + tipo.id,
                Nombre: pago.Nombre + " " + tipo.Nombre,
              };
            }
          });
        }
      });
      return pagos;
    },
    venta() {
      return this.$pgsHelper.cloneObj(this.dataVenta);
    },
  },
  beforeMount: async function () {
    this.getCashiers();
    this.getCajas();
    this.getMeserosAB();
  },
};
</script>

<style scoped>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}

.editsButtons {
  width: 100px !important;
  max-width: 100px !important;
  min-width: 100px !important;
}
</style>
